export default {"src":"/_next/static/media/integrations-4.bf8201f5.svg","height":121,"width":101,"blurWidth":0,"blurHeight":0};